type CanonicalStatsTextRendererProps = {
  num?: number | null;
};

// برای نمایش وضعیت کنونیکال
const CanonicalStatsTextRenderer = ({
  num
}: CanonicalStatsTextRendererProps) => {
  const giveNum = () => {
    switch (num) {
      case 2:
        return 'نداره';
      case 1:
        return 'داره به خود';
      case 0:
        return 'داره به غیر';
    }
  };
  return <div>{giveNum()}</div>;
};

export default CanonicalStatsTextRenderer;
